import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { TeamDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class TeamService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  getByVendorId = (vendorId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TeamDto[]>({
      method: 'GET',
      url: `/api/app/team/by-vendor-id/${vendorId}`,
    },
    { apiName: this.apiName,...config });
}